'use strict';

goog.provide("Ntry.Item");

goog.require("Ntry.STATIC");

Ntry.Item = function(item) {
    this.tolerance = item.tolerance ? item.tolerance : 10;

    this.itemType = item.itemType;

    this.sequence = item.sequence;

    this.isEaten = false;
};

Ntry.Item.prototype.type =
    Ntry.STATIC.ITEM;
